import React, {useContext, useEffect, useState} from 'react'
import { compose } from 'redux'
import { injectActions as injectSnackbarActions } from 'isotope-client/components/snackbar/services/snackbarInjector'
import { useParams } from 'react-router-dom'
import { injectToolbarData } from 'isotope-client'
import { FormattedMessage } from 'react-intl'
import { getTrackerByID, updateTracker, updateTrackerStatus } from './services/trackerApi'
import { RequestCreateOrUpdateTrackerFormModel } from './services/trackerModel'
import TrackerForm from './components/TrackerForm'
import errorsMapper from '../../../utils/errorsMapper'
import { REFERENTIEL } from '../../common/phidemData/phidemDataModel'
import { PhidemDataContext } from '../../common/phidemData/PhidemDataContext'

interface MatchParamsModel {
    id: string
}

interface TrackerCreateProps {
    snackSuccess: (value: any) => void,
    snackError: (value: any) => void,
}

const TrackerCreate: React.FC<TrackerCreateProps> = (
    {
        snackSuccess,
        snackError
    }) => {
    const { id: idInUrl } = useParams<MatchParamsModel>()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [fetchedTracker, setFetchedTracker] = useState<RequestCreateOrUpdateTrackerFormModel>()
    const { reloadReferentiel } = useContext(PhidemDataContext)

    useEffect(() => {
        getTrackerByID(idInUrl)
            .then((response: RequestCreateOrUpdateTrackerFormModel) => {
                return setFetchedTracker(response)
            })
            .finally(() => setIsLoading(false))
    }, [idInUrl])

    const handleTrackerStatus = () => {
        updateTrackerStatus(idInUrl, !fetchedTracker?.actif)
            .then(() => {
                setFetchedTracker({
                    ...fetchedTracker as RequestCreateOrUpdateTrackerFormModel,
                    actif: !fetchedTracker?.actif
                })
                snackSuccess({ id: 'tracker.updateStatusSuccess', defaultMessage: 'Le statut du tracker a bien été modifié', description: 'Success message' })
                reloadReferentiel(REFERENTIEL.TRACKER)
            })
            .catch(() => snackError({ id: 'tracker.updateStatusError', defaultMessage: 'Une erreur est survenue, le statut du tracker n\'a pas été modifiée', description: 'Error message' }))
    }

    const onSubmit = async (formValues: any) => {
        return updateTracker(idInUrl, formValues)
            .then((response: RequestCreateOrUpdateTrackerFormModel) => {
                setFetchedTracker(response)
                snackSuccess({ id: 'tracker.updateSuccess', defaultMessage: 'Le tracker a bien été modifié', description: 'Success message' })
            })
            .catch((e: any) => {
                const { errors, displayFields } = errorsMapper(e)
                if (displayFields) {
                    snackError({ id: 'global.error.formError', defaultMessage: 'Votre formulaire comporte des erreurs', description: 'Form error message' })
                    reloadReferentiel(REFERENTIEL.TRACKER)
                } else {
                    snackError({ id: 'tracker.updateError', defaultMessage: 'Une erreur est survenue, le tracker n\'a pas été modifié', description: 'Error message' })
                }
                return errors
            })
    }

    return (
        <TrackerForm
            isLoading={isLoading}
            initialValues={fetchedTracker}
            onSubmit={onSubmit}
            isCreationForm={false}
            updateTrackerStatus={handleTrackerStatus}
        />
    )
}

export default compose<any>(injectToolbarData(() => ({
    title: <FormattedMessage
        id="tracker.pageTitle.update"
        defaultMessage="Modifier un tracker"
        description="Page title"
    />
})), injectSnackbarActions)(TrackerCreate)
